
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"65","height":"64","viewBox":"0 0 65 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","width":"64","height":"64","rx":"32","fill":"url(#paint0_linear_831_7445)","fill-opacity":".7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.271 26.47l5.611-3.239a.903.903 0 011.34.948 5.43 5.43 0 003.01 5.906l4.74 2.249c.265.125.28.496.026.642l-10.845 6.262a.363.363 0 01-.544-.344l.423-5.23a5.43 5.43 0 00-3.609-5.56.903.903 0 01-.151-1.633zm4.611-4.97c2.148-1.24 4.762.61 4.305 3.047a3.43 3.43 0 001.902 3.731l4.74 2.249c1.722.816 1.82 3.229.17 4.181L30.152 40.97c-1.65.953-3.69-.338-3.537-2.237l.423-5.23a3.43 3.43 0 00-2.28-3.512c-2.34-.824-2.635-4.012-.488-5.252l5.611-3.24z","fill":"#EF7D22"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.849 35.892a1 1 0 00-.366 1.366l3.544 6.139a1 1 0 001.732-1l-3.544-6.139a1 1 0 00-1.366-.366z","fill":"#EF7D22"}})])
          )
        }
      }
    